import { Usecase } from '..'

export class IsStorybookEnabledUsecase extends Usecase {
    invoke (): boolean {
        return this.configurationService.isStorybookEnabled()
    }
}
